/**
 * Route for `log-level-data-access`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { LogLevelDataAccessPage } from "../features/log-level-data-access/LogLevelDataAccessPage";

export const logLevelDataAccessRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/log-level-data-access",
	component: LogLevelDataAccessPage,
});

export default logLevelDataAccessRoute;
